var map = {
	"./mobile/newsDetails.vue": [
		"d2a7",
		"chunk-119afbf8",
		"chunk-183789f6"
	],
	"./pc/newsDetails.vue": [
		"a50e",
		"chunk-119afbf8",
		"chunk-23263ff1"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "6fc1";
module.exports = webpackAsyncContext;